import React from 'react';
import { ChevronRight, TrendingUp } from 'lucide-react';
interface Recommendation {
  id: string;
  title: string;
  type: string;
  diamondRange: string;
  reason: string;
  ctaLabel: string;
  onCtaClick: () => void;
}
interface AIRecommendationPanelProps {
  recommendations: Recommendation[];
  title?: string;
  lastUpdated?: string;
}
export const AIRecommendationPanel: React.FC<AIRecommendationPanelProps> = ({
  recommendations,
  title = 'Suggerimenti AI',
  lastUpdated = 'Ultimi 30 giorni'
}) => {
  return <div className="space-y-4" data-id="element-160">
      {/* Recommendations */}
      {recommendations.slice(0, 2).map((rec, index) => <div key={rec.id} className="bg-white border border-gray-200 rounded-lg p-4 hover:border-gray-300 transition-colors" data-id="element-161">
          <div className="flex items-start justify-between mb-2" data-id="element-162">
            <div className="flex-1" data-id="element-163">
              <div className="flex items-center gap-2 mb-1" data-id="element-164">
                <span className="flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold" style={{
              background: 'linear-gradient(90deg, rgba(255, 0, 77, 0.1) 0%, rgba(116, 10, 214, 0.1) 100%)',
              color: '#740AD6'
            }} data-id="element-165">
                  {index + 1}
                </span>
                <h4 className="font-medium text-gray-900" data-id="element-166">{rec.title}</h4>
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500 mb-2" data-id="element-167">
                <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded-full" data-id="element-168">
                  {rec.type}
                </span>
                <span className="flex items-center gap-1" data-id="element-169">
                  <TrendingUp className="h-3 w-3" data-id="element-170" />
                  {rec.diamondRange}
                </span>
              </div>
              <p className="text-sm text-gray-600" data-id="element-171">{rec.reason}</p>
            </div>
          </div>

          {/* Compact CTA with gradient outline */}
          <div className="inline-block mt-3" style={{
        background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 100%)',
        padding: '2px',
        borderRadius: '100px'
      }} data-id="element-172">
            <button onClick={rec.onCtaClick} className="flex items-center gap-1 text-xs font-medium bg-white text-black px-3 py-1.5 hover:bg-gray-50 transition-colors" style={{
          borderRadius: '100px'
        }} data-id="element-173">
              {rec.ctaLabel}
              <ChevronRight className="h-3.5 w-3.5" data-id="element-174" />
            </button>
          </div>
        </div>)}

      {/* Privacy Notice */}
      <div className="pt-4 border-t border-gray-200" data-id="element-175">
        <p className="text-xs text-gray-400" data-id="element-176">
          Basato su dati aggregati. Nessun dato personale.
        </p>
      </div>
    </div>;
};